import React from 'react'
import NoIndex from '#src/components/NoIndex'
import { isBotUserAgent } from '@deal/is-bot'
import { withUserAgent, WithUserAgentProps } from '#src/containers/UserAgent'
import { ResponseConsumer } from '#src/context/response'
import { Grid, GridItem } from '@deal/components'
import Link from './link.svg'
import styles from './styles.css'

interface EntityNotFoundProps {
  header: React.ReactNode
  body?: React.ReactNode
}

const EntityNotFound: React.SFC<EntityNotFoundProps & WithUserAgentProps> = ({
  children,
  header,
  body,
  userAgent
}) => {
  return (
    <ResponseConsumer>
      {context => {
        /**
         * Restrict mutation of status codes to bot traffic only, we can't modify
         * the headers for our regular (non-bot) SSR since we stream the response.
         */
        if (context && userAgent && isBotUserAgent(userAgent.raw)) {
          context.handleSetStatusCode(404)
        }

        return (
          <>
            <NoIndex />
            <Grid>
              <GridItem col={2}>
                <div className={styles.wrapper}>
                  <div className={styles.copy}>
                    <div className={styles.header}>{header}</div>
                    {body && <div className={styles.body}>{body}</div>}
                  </div>
                  <div className={styles.icon}>
                    <Link className={styles.linkIcon} />
                  </div>
                </div>
              </GridItem>
            </Grid>
            {children}
          </>
        )
      }}
    </ResponseConsumer>
  )
}

export default withUserAgent(EntityNotFound)
